'use strict';

var buildMathAliases = require('../internal/buildMathAliases');

buildMathAliases();


//////////////////
// WEBPACK FOOTER
// ./~/sugar/number/build/buildMathAliasesCall.js
// module id = 21
// module chunks = 0